import { createStore } from 'vuex';
import modules from './modules';

export const isAuthenticated = localStorage.getItem('accessToken') ? true : false;

const getSession = () => {
  if (isAuthenticated) {
    return {
      accessToken: localStorage.getItem('accessToken'),
      accessExpiresAt: localStorage.getItem('accessExpiresAt'),
      refreshExpiresAt: localStorage.getItem('refreshExpiresAt'),
      refreshToken: localStorage.getItem('refreshToken'),
      user: localStorage.getItem('user')
    };
  }
  return {};
};

// eslint-disable-next-line no-unused-vars
const store = createStore({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
  state() {
    return {
      isAuthenticated: isAuthenticated,
      session: getSession(),
      reportAffiliateDetail: {},
      isLoading: false,
      count: 0,
      params: {},
      partnerAccess: {},
      menuItems: [],
      companySettings: null
    };
  },
  mutations: {
    SET_LOADING(state, value) {
      state.isLoading = value;
    },
    SET_AUTHENTICATED(state, value) {
      state.isAuthenticated = value;
    },
    SET_SESSION(state, session) {
      state.session = session;
      state.partnerAccess = {};
    },
    SET_REPORT_MOVIMENTO(state, value) {
      state.reportAffiliateDetail = value;
    },
    increment(state) {
      state.count++;
    },
    SET_PARTNER_ACCESS(state, value) {
      state.partnerAccess = value;
    },
    SET_PARAMS(state, value) {
      state.params = value;
    },
    SET_MENU_ITEMS(state, value) {
      state.menuItems = value;
    },
    SET_COMPANY_SETTINGS(state, settings) {
      state.companySettings = settings;
    }
  },
  actions: {
    setReportMovimento({ commit }, value) {
      commit('SET_REPORT_MOVIMENTO', value);
    },
    increment(context) {
      context.commit('increment');
    }
  }
});

export default store;
